import { Switch } from "antd";
import moment from "moment";

// Removed old export to avoid redeclaration error
export const emailColumns = (navigate, handleSwitchToggle, switchStates = {}) => [
  {
    title: "Template Name",
    key: "templateName",
    dataIndex: "templateName",
    // sorter: {
    //   compare: (a, b) => a.templateName.localeCompare(b.templateName),
    // },
  },
  // {
  //   title: 'Trigger Level',
  //   key: "triggerLevel",
  //   dataIndex: 'triggerLevel',
  //   sorter: {
  //     compare: (a, b) => a.triggerLevel.localeCompare(b.triggerLevel),
  //   },
  // },
  // {
  //   title: 'ID',
  //   key: "code",
  //   dataIndex:"code",
  //   // sorter: {
  //   //   compare: (a, b) => a.code.localeCompare(b.code),
  //   // },
  // },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    // sorter: {
    //   compare: (a, b) => a.date.localeCompare(b.date),
    // },
    render: (date) => {
      if (date) {
        const dt = moment(date);
        const formattedDate = dt.format("YYYY-MM-DD");

        return formattedDate;
      }
    },
  },
  {
    title: <div style={{ textAlign: "center", width: "100%" }}>Action</div>,
    dataIndex: "action",
    key: "action",
    width: 135,
    align: "center",
 
    render: (_, record) => (
      <>
        <Switch
          className="me-3 switches"
          checked={!!switchStates[record.id]}
          onChange={(checked) => handleSwitchToggle(record, checked)}
        />
        <button
          className="manage"
          onClick={() =>
            navigate(`/manage-email-template`, {
              state: {
                manageData: {
                  id: record?.id,
                  templateName: record?.templateName,
                  emailBody: record?.emailBody,
                  emailBodySpanish: record?.emailBodySpanish,
                  emailSubject: record?.emailSubject,
                  emailSubjectSpanish: record?.emailSubjectSpanish,
                  eventType: record?.eventType,
                  enabled: record?.enabled,
                  code: record?.code,
                  createdAt: record?.createdAt,
                  modifiedAt: record?.modifiedAt,
                },
              },
            })
          }
        >
          Manage
        </button>
      </>
    ),
  },
];
